<template>
  <el-main class="userwrap">
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>用户管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/user' }">用户信息</el-breadcrumb-item>
        <el-breadcrumb-item>{{ pathtype }}用户信息</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form myform">
      <el-form ref="form" :model="form" :rules="rules" label-width="150px" label-position="left">
        <div class="formtitle">用户信息</div>
        <el-form-item label="姓名：" prop="nickname">
          <el-col :span="12">
            <el-input style="width: 100%;" placeholder="请输入" maxlength="100" v-model="form.nickname" clearable />
          </el-col>
        </el-form-item>

        <el-form-item label="手机号：" prop="phone">
          <el-col :span="12">
            <el-input style="width: 100%;" placeholder="请输入" maxlength="100" v-model="form.phone" clearable />
          </el-col>
        </el-form-item>

        <el-form-item label="地区：" prop="quyu">
          <el-col :span="12">
            <el-cascader style="width: 100%;" :options="options" v-model="form.quyu" @change="handleChange">
            </el-cascader>
          </el-col>
        </el-form-item>

        <el-form-item label="地址：" prop="address">
          <el-col :span="12">
            <el-input style="width: 100%;" placeholder="请输入" maxlength="100" v-model="form.address" clearable />
          </el-col>
        </el-form-item>

        <el-form-item label="推荐人手机：" prop="recommend">
          <el-col :span="12">
            <el-input style="width: 100%;" placeholder="请输入" maxlength="100" v-model="form.recommend" clearable />
          </el-col>
        </el-form-item>

        <el-form-item label="门店：" prop="shop_id">
          <el-col :span="12">
            <el-select v-model="form.shop_id" placeholder="请选择" style="margin-right: 0; width: 100%;">
              <el-option :label="v.name" :value="v.id" v-for="(v, d) in shopList" :key="`shop_${d}`"></el-option>
            </el-select>
          </el-col>
        </el-form-item>

        <el-form-item label="">
          <el-col>
            <el-button @click="resetForm('form')">取消</el-button>
            <el-button type="primary" @click="submitForm('form')">保存</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </div>
  </el-main>
</template>


<script>
import * as api from '@/api'
import { regionData, CodeToText, TextToCode } from 'element-china-area-data'
export default {
  name: 'UserDetail',
  data() {
    return {
      options: regionData,
      form: {
        quyu: ['', '', ''],
      },
      shopList: [],
      perPage: 30,
      p: 1,
      total: 30,
      rules: {
        phone: [
          {
            required: true,
            message: '请填写您的手机号',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {

  },
  created() {
    this.$route.query.id && this.getUserDetail(this.query.id)
    this.getShopList()
  },
  methods: {
    async getUserDetail(id) {
      api.getUserDetail({
          user_id: id,
        })
        .then((res) => {
          let {
            id,
            nickname,
            phone,
            province,
            city,
            area,
            address,
            recommend,
            shop_id
          } = res.resData
          if (city == '北京市' || city == '上海市' || city == '天津市' || city == '重庆市') { //两种不同差价需要处理
            city = '市辖区'
          }
          this.form = {
            id,
            nickname,
            phone,
            province,
            city,
            area,
            address,
            recommend,
            shop_id,
            quyu: [
              TextToCode?.[province]?.code,
              TextToCode?.[province]?.[city]?.code,
              TextToCode?.[province]?.[city]?.[area]?.code,
            ],
          }
          this.$forceUpdate()
          return res
        })
    },
    async getShopList() {
      const postData ={}
      api.getShopList(postData)
      .then((res) => {
        this.shopList = res.resData.itemList
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.updateUser()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    updateUser() {
      this.form.user_id = this.form.id
      this.form.option = this.form.id ? '2' : '1'
      const _province = CodeToText[this.form.quyu[0]]
      this.form.province = _province
      //同步前端页面
      if (_province == '北京市') {
        this.form.city = '北京市'
      } else if (_province == '上海市') {
        this.form.city = '上海市'
      } else if (_province == '天津市') {
        this.form.city = '天津市'
      } else if (_province == '重庆市') {
        this.form.city = '重庆市'
      } else {
        this.form.city = CodeToText[this.form.quyu[1]]
      }
      this.form.area = CodeToText[this.form.quyu[2]]
      const tempForm = JSON.parse(JSON.stringify(this.form))
      delete tempForm.id
      delete tempForm.quyu
      api.updateUserInfo(tempForm).then((res) => {
        if (res.status == 200) {
          this.$message.success(res)
          this.$router.go(-1)
        }
      })
    },
    handleChange(value) {
      console.log(CodeToText, value)
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.$router.go(-1)
    },
  },
}
</script>

<style lang="scss" scoped>
.userwrap {
  .form.myform {
    padding-left: 100px;
  }

  .form {
    @extend %box;
    padding: 30px;
    margin-bottom: 20px;

    .anlist {
      padding: 0;
      flex-flow: column nowrap;

      li {
        position: relative;
        padding: 0;

        .abtn {
          position: absolute;
          top: 0;
          left: 65%;
        }

        .bbtn {
          position: absolute;
          top: 0;
          left: 60%;
        }
      }
    }
  }

  .formtitle {
    position: relative;
    left: -50px;
    margin-bottom: 30px;
    font-size: 28px;
    line-height: 48px;
    font-weight: 600;
  }
}
</style>